import { render, staticRenderFns } from "./CsvDateEditPage.vue?vue&type=template&id=2636a925&"
import script from "./CsvDateEditPage.vue?vue&type=script&lang=ts&"
export * from "./CsvDateEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports